<template>
  <i-ep-tickets />
</template>
